export default "__VITE_ASSET__brS90mMl__"